import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';
import { Switcher } from '@shared/fields';
import {
  FONT_FAMILY_MAIN, NOTES_COLOR, PALE_GREY, TEXT_COLOR,
} from '../../../theme';
import { EXAM_CENTERS_SORT_FILTERS, EXAM_CENTERS_TYPES_FILTERS } from './constants';
import { InfoLabel } from '../../common/InfoLabel';
import stores from '../../../stores';
import media from '../../../utils/mediaQueries';
import { Z_INDEXES } from '../../../constants';

const Container = styled.div`
  border-bottom: 1px solid ${PALE_GREY};
  padding: 16px 0 24px;
`;

const FiltersGroup = styled.div`
  display: inline-flex;
  flex-direction: column;
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.2px;
  color: ${TEXT_COLOR};
  white-space: nowrap;
  
  & + & {
    margin-left: 64px;
  }
  
  ${media.mobile`
    margin: 0 -10px;
    display: flex;
    align-items: flex-start;
    
    & + & {
      margin-left: -10px;
      margin-top: 25px;
    }
  `}
`;

const TooltipSection = styled.section`
  font-size: 9px;
  line-height: 1.38;
  letter-spacing: -0.1px;
  color: ${NOTES_COLOR};
    
  &+& {
    margin-top: 8px;
  }
`;

const TooltipHeader = styled.h4`
   font-weight: 600;
   margin: 0 0 4px;
   font-size: 9px;
`;

const TooltipCont = styled.p`
  margin: 0;
  white-space: normal;
`;

const getTypesFilterTooltipCont = () => (
  <>
    <TooltipSection>
      <TooltipHeader>Tous (par défaut)</TooltipHeader>
      <TooltipCont>Affiche l&#39;ensemble des centre d&#39;examen. Lorsqu&#39;un ou plusieurs opérateurs sont.</TooltipCont>
    </TooltipSection>
    <TooltipSection>
      <TooltipHeader>Sélectionnés</TooltipHeader>
      <TooltipCont>Affiche uniquement les centres d&#39;examen de cet (ou ces) opérateur(s).</TooltipCont>
    </TooltipSection>
  </>
);

const getSortFilterTooltipCont = () => (
  <>
    <TooltipSection>
      <TooltipHeader>Proximité</TooltipHeader>
      <TooltipCont>Affiche les centres d&#39;examen les plus proches géographiquement du lieu de la recherche. Par défaut, les centres d&#39;examen permettant la réservation d&#39;une session d&#39;examen sont en tête de liste.</TooltipCont>
    </TooltipSection>
    <TooltipSection>
      <TooltipHeader>Prochaine session</TooltipHeader>
      <TooltipCont>Affiche les centres d&#39;examen permettant la réservation d&#39;une place d&#39;examen en ligne. Les centres ayant les sessions les plus proches de la date actuelle sont en haut de liste.</TooltipCont>
    </TooltipSection>
  </>
);

class FiltersClassComponent extends Component {
  handleExamCenterChange = (e) => {
    stores.examCentersSearchStore.filterByExamCenters(e.target.value);
  };

  handleSortChange = (e) => {
    stores.examCentersSearchStore.selectedSort = e.target.value;
  };

  render() {
    const { tooltipPosition, isInSeparateMode, tooltipWidth } = this.props;

    return (
      <Container>
        <div className="container">
          <FiltersGroup>
            <InfoLabel label="Centre d&apos;examen" infoText={getTypesFilterTooltipCont()} tooltipPosition={tooltipPosition} tooltipWidth={tooltipWidth} zIndex={Z_INDEXES.HEADER + 2} />
            <Switcher
              items={EXAM_CENTERS_TYPES_FILTERS}
              name="examCenters"
              fontSize={14}
              isMultipleChoiceAllowed
              activeItem={stores.examCentersSearchStore.selectedExamCentersFilters}
              onChange={this.handleExamCenterChange}
              isInSeparateMode={isInSeparateMode}
            />
          </FiltersGroup>
          <FiltersGroup>
            <InfoLabel label="Trier par" infoText={getSortFilterTooltipCont()} tooltipPosition={tooltipPosition} tooltipWidth={tooltipWidth} zIndex={Z_INDEXES.HEADER + 1} />
            <Switcher
              items={EXAM_CENTERS_SORT_FILTERS}
              name="sortFilters"
              fontSize={14}
              activeItem={stores.examCentersSearchStore.selectedSort}
              onChange={this.handleSortChange}
            />
          </FiltersGroup>
        </div>
      </Container>
    );
  }
}

FiltersClassComponent.propTypes = {
  tooltipPosition: PropTypes.string,
  isInSeparateMode: PropTypes.bool,
  tooltipWidth: PropTypes.number,
};

FiltersClassComponent.defaultProps = {
  tooltipPosition: 'right center',
  isInSeparateMode: false,
  tooltipWidth: 250,
};

const Filters = observer(FiltersClassComponent);

export { Filters };
